import { useEffect } from 'react';

interface PageSeoProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogType?: string;
  ogImage?: string;
  noIndex?: boolean;
}

export default function PageSeo({
  title,
  description,
  keywords,
  canonical,
  ogType = 'website',
  ogImage,
  noIndex = false,
}: PageSeoProps) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (selector: string, content: string, attr = 'name') => {
      let el = document.querySelector<HTMLMetaElement>(`meta[${attr}="${selector}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, selector);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    if (description) setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);
    if (noIndex) setMeta('robots', 'noindex, nofollow');

    if (canonical) {
      let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = canonical;
    }

    if (title) setMeta('og:title', title, 'property');
    if (description) setMeta('og:description', description, 'property');
    if (ogType) setMeta('og:type', ogType, 'property');
    if (canonical) setMeta('og:url', canonical, 'property');
    if (ogImage) setMeta('og:image', ogImage, 'property');

    if (title) setMeta('twitter:title', title);
    if (description) setMeta('twitter:description', description);
    if (ogImage) setMeta('twitter:image', ogImage);
  }, [title, description, keywords, canonical, ogType, ogImage, noIndex]);

  return null;
}
